import { CalendarDays, Phone, MessageCircle } from "lucide-react";
import { FIRM } from "@/lib/site";
import { useLang } from "@/lib/lang";

export default function TopBar() {
  const { t } = useLang();
  return (
    <div data-testid="topbar-appointment-notice" className="fixed inset-x-0 top-0 z-[60] bg-navy-ink text-alabaster">
      <div className="mx-auto flex h-9 max-w-[1400px] items-center justify-center gap-4 px-4 font-mono text-[9px] uppercase tracking-[0.18em] sm:justify-between lg:px-12">
        <p className="flex items-center gap-2 text-gold">
          <CalendarDays size={11} strokeWidth={1.5} />
          {t.topbar.hours}
        </p>
        <div className="hidden items-center gap-5 sm:flex">
          <a
            data-testid="topbar-phone"
            href={`tel:${FIRM.phoneHref}`}
            className="flex items-center gap-1.5 text-alabaster/80 transition-colors hover:text-gold"
          >
            <Phone size={11} strokeWidth={1.5} />
            {FIRM.phone}
          </a>
          <a
            data-testid="topbar-whatsapp"
            href={FIRM.whatsappHref}
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center gap-1.5 text-alabaster/80 transition-colors hover:text-gold"
          >
            <MessageCircle size={11} strokeWidth={1.5} />
            WhatsApp {FIRM.whatsapp}
          </a>
        </div>
      </div>
    </div>
  );
}
